import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import React from "react";

const Callback = (): JSX.Element => {
  const history = useHistory();

  useEffect(() => {
    const handleLogin = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const session = await Auth.currentSession();

        const idToken = session.getIdToken().getJwtToken();

        console.log(user,"user")
        
        const decodedToken: any = jwtDecode(idToken);
        const groups = decodedToken["cognito:groups"] || [];

          localStorage.setItem("email", decodedToken.email);
          localStorage.setItem("nombre", decodedToken.middle_name);
          localStorage.setItem("apellido", decodedToken.family_name);
          history.push("/");
      } catch (err) {
        console.error("Error autenticando usuario:", err);
        history.push("/");
      }
    };

    handleLogin();
  }, []); 

  return <div></div>;
};

export default Callback;
